<template>
  <span>
    <a-input
      type="text"
      :value="number"
      @change="handleNumberChange"
      style="width: 63%; margin-right: 2%;"
    />
    <span>RMB</span>
  </span>
</template>

<script lang="ts">
export default {
  name: 'PriceInput',
  props: {
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: Number
    }
  },
  data () {
    return {
      number: 0
    }
  },
  watch: {
    value (val) {
      this.number = val || 0
    }
  },
  methods: {
    handleNumberChange (e) {
      const number = parseInt(e.target.value)
      console.log(number, isNaN(number))
      if (isNaN(number)) {
        this.$emit('change', 0)
        return false
      }
      this.triggerChange(number)
    },
    triggerChange (changedValue) {
      this.$emit('change', changedValue)
    }
  }
}
</script>
